import axios from 'axios';
export default axios.create({
    baseURL: process.env.casBaseUrl + "/api/v2/",
    headers: {
        ContentType: 'application/json'
    }
});
